import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { useDispatch } from 'react-redux';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

interface CustomErrorPopupProps {
  message: string;
}

export default function CustomErrorPopup({ message }: CustomErrorPopupProps) {
  const dispatch = useDispatch();
  const reason = message.split(' ').includes('Reason');
  const Description = message.split(' ').includes('Description');

  const handleClose = () => {
    dispatch(handleError(''));
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={true}
      >
        <Box sx={{ color: 'error ' }}>
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            <Typography variant="h4">
              {reason
                ? 'Reason of Rejection'
                : Description
                ? 'Tree Permit Closeout Description'
                : 'Error Occurred'}
            </Typography>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500]
            })}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent dividers>
          <Typography
            minWidth={'275px'}
            minHeight={'50px'}
            variant="h6"
            gutterBottom
          >
            {message}
          </Typography>
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
